import { MutationTree, StoreOptions, Module, GetterTree, ActionTree } from 'vuex';
import { VuexState } from '@/interfaces/vuexStateInterface';
import VuexModuleState from '@/interfaces/vuexModuleStateInterface';
import { Dialog } from 'vant';
import { getCurrentHudong, getCurrentRace, InterfaceLiveRecordItem } from '@/apis/onlineLive';

const mutations: MutationTree<VuexModuleState> = {
  setReplyType(state, data) {
    state.replyType = data;
  },
  setFinishState: (state, flag) => {
    state.isShowFinishDialog = flag;
  },
  setVideoPlayerStatus(state, data) {
    state.videoPlayerStatus = data;
  },
  setVideoPlayerCurrentTime(state, data) {
    state.videoPlayerCurrentTime = data
  },
  setFileFlag(state, data) {
    state.FileFlag = data;
  },
};
const getters: GetterTree<VuexModuleState, VuexState> = {
  getReplyType(state) {
    return state.replyType;
  },
  getFinishDialog(state) {
    return state.isShowFinishDialog;
  }
};
const actions: ActionTree<VuexModuleState, VuexState> = {
  getCurrentActive(
    ctx,
    data: {
      courseId: string;
      classTimeId: string;
      type: number;
    }
  ) {
    return new Promise((resolve, reject) => {
      const { type, courseId, classTimeId } = data;
      const list: InterfaceLiveRecordItem[] = [];
      async function getQueue() {
        if (type === 1 || type === 0) {
          const res = await getCurrentRace({ courseid: courseId });
          if (Object.prototype.toString.call(res) === '[object Object]') {
            list.push(res);
          }
        }
        if (type === 3 || type === 0) {
          const res = await getCurrentHudong({
            courseid: courseId,
            classtimeid: classTimeId
          });
          if (res && res.stepid.length) {
            let ids: string | string[];
            if (res.stepid.length === 1) {
              ids = res.stepid[0].id;
            } else {
              ids = [];
              res.stepid.forEach(ele => {
                (ids as string[]).push(ele.id);
              });
            }
            list.push({
              type: '3',
              // @ts-ignore
              data: { id: ids }
            });
          }
        }
        resolve(list);
      }
      getQueue();
    });
  }
};
const courseStore: Module<VuexModuleState, VuexState> = {
  namespaced: true,
  state: {
    replyType: 1, // 讨论区-文本输入弹窗类型    1  发表评论  2 回复
    isShowFinishDialog: true, // 是否显示已完成学习弹窗
    videoPlayerStatus: false, // 视频播放状态   false、暂停  true、播放
    videoPlayerCurrentTime: 0, // 视频当前播放时间
    seniorSettingParams: {}, // 课程高级设置参数
    FileFlag:true, // 评论显示附件
  },
  getters,
  mutations,
  actions
};

export default courseStore;
